import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../../errorhandling';
import { queryClientTwins } from '../../../clientTwins';
import router from '../../../router/router';

let localSubscription = undefined;

async function createSubscription(store, clientId) {
	const all_clients = await queryClientTwins(clientId);
	if (!all_clients) {
		// Delete elsewhere, nothing left to subscribe here.
		return;
	}

	let dataQuery = new Parse.Query('MedicationReport');
	dataQuery.notEqualTo("deleted", true)
	dataQuery.include(["otherFiles", "diagnose", "doctor", "doctor.specialization", "icd_10_code_array"])
	// var clientPointer = {
	// 	__type: 'Pointer',
	// 	className: 'Client',
	// 	objectId: clientId
	// }

	// dataQuery.equalTo("client", clientPointer)
	dataQuery.containedIn("client", all_clients)

	dataQuery.find()
		.then((results) => {
			store.dispatch('medicationReport/set', results)
		})
		.catch((error) => {
			handleParseError(error);
		
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('medicationReport/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('medicationReport/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('medicationReport/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('medicationReport/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('medicationReport/delete', object)
		});
		subscription.on('close', () => {
			
		});
		subscription.on('error', error => {
			
		})
	})
}
export default function createReportSubscription() {
	return store => {
		store.subscribe(mutation => {
			if (mutation.type === 'clients/SET_FOCUSED_CLIENT_ID' && (router.currentRoute.name == "Medication" || router.currentRoute.name == "MedicationEntry")) {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if(mutation.payload)
				{
					createSubscription(store, mutation.payload)
				}
			}
		}),
		store.subscribe(mutation => {
			if (mutation.type === 'ADD_LAST_ROUTE' && (router.currentRoute.name == "Medication" || router.currentRoute.name == "MedicationEntry")) {
				if (localSubscription) {
					localSubscription.unsubscribe();
				}
				if (store.state.clients.focusedClientId) {
					createSubscription(store, store.state.clients.focusedClientId)
				}
			}
		})
	}
}
